export default __webpack_public_path__ + "static/media/stop-favicon.b2a65535.ico";